export default {
  normal_attack: 'normal_attack_talent',
  charged_attack: 'normal_attack_talent',
  plunge_attack: 'normal_attack_talent',
  elemental_skill: 'elemental_skill_talent',
  elemental_burst: 'elemental_burst_talent'
};
